<div class="form-content-item">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <div class="form-header-item">
      <div>
        <h2 *ngIf="currentItem?.displayName">{{ currentItem.displayName }} [{{ currentItem.code }}]</h2>
      </div>
      <div class="div-btns-top">
        <action-bar
          [showSave]="manageProducts && (currentItem?.canUpdate == true || !currentItem?.resourceId)"
          [showAddToFavorites]="!favoriteId && currentItem && currentItem.resourceId"
          [showRemoveFromFavorites]="favoriteId"
          [showDuplicate]="!!currentItem?.canDuplicate"
          [showDelete]="(manageProducts && (currentItem?.canUpdate == true || !currentItem?.resourceId) && currentItem && currentItem.resourceId) || currentItem?.canUnlink"
          [showShare]="currentItem?.resourceId && manageProducts && currentItem?.canUpdate === true && currentItem?.ruade !== true"
          (onSave)="clickSave(form.value)"
          (onAddToFavorites)="addToFavorite(currentItem.resourceId!)"
          (onRemoveFromFavorites)="removeFromFavorite()"
          (onDuplicate)="onDuplicate(currentItem.resourceId!)"
          (onDelete)="onDeleteDialog(currentItem.resourceId!)"
          (onShare)="onShare(currentItem.resourceId!)"></action-bar>
      </div>
    </div>
    <div>
      <div class="readonly-banner" *ngIf="isFormDisable()">
        <mat-icon>lock</mat-icon>
        <span>{{ 'common_read_only_notice' | translate }}</span>
      </div>
      <div class="identification" [class]="{ 'disabled-form': isFormDisable() }">
        <h3 class="title-margin-top">{{ 'common_section_identification' | translate }}</h3>
        <mat-card>
          <mat-grid-list cols="10" rowHeight="60px" gutterSize="20px">
            <mat-grid-tile colspan="2">
              <mat-form-field>
                <mat-label color="accent">{{ 'common_field_code' | translate }}</mat-label>
                <input matInput formControlName="code" minlength="2" maxlength="15" required />
                <mat-error *ngIf="formCrls.code.invalid">{{ 'product_error_code_required' | translate }}</mat-error>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3">
              <mat-form-field>
                <mat-label>{{ 'common_field_label' | translate }}</mat-label>
                <input matInput formControlName="displayName" maxlength="100" required />
                <mat-hint align="end">{{ form.value.displayName?.length || 0 }} / 100</mat-hint>
                <mat-error *ngIf="formCrls.displayName.invalid">{{ 'ref_error_label_required' | translate }}</mat-error>
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="3" *ngIf="currentItem?.resourceId">
              <mat-form-field>
                <mat-label>{{ 'common_field_owner' | translate }}</mat-label>
                <input matInput disabled [value]="formCrls.owner.value | resourceAuthor: currentItem" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="2" *ngIf="currentItem?.resourceId">
              <mat-form-field>
                <mat-label>{{ 'common_field_creator' | translate }}</mat-label>
                <input matInput disabled [value]="formCrls.creator.value | resourceAuthor: currentItem" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="2" *ngIf="currentItem?.resourceId && currentItem?.createDate">
              <mat-form-field>
                <mat-label>{{ 'project_field_creation_date' | translate }}</mat-label>
                <input disabled matInput value="{{ currentItem?.createDate | localizedDate: 'shortDate' }}" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="2" *ngIf="currentItem?.resourceId && currentItem?.updateDate && currentItem?.updateDate !== currentItem?.createDate">
              <mat-form-field>
                <mat-label>{{ 'project_field_last_modification_date' | translate }}</mat-label>
                <input disabled matInput value="{{ currentItem?.updateDate | localizedDate: 'shortDate' }}" />
              </mat-form-field>
            </mat-grid-tile>
            <mat-grid-tile colspan="2" *ngIf="currentItem?.resourceId && currentItem?.modifier && currentItem?.modifier !== ' ' && currentItem?.updateDate !== currentItem?.createDate">
              <mat-form-field>
                <mat-label>{{ 'project_field_modified_by' | translate }}</mat-label>
                <input disabled matInput [value]="currentItem?.modifier | resourceAuthor: currentItem" />
              </mat-form-field>
            </mat-grid-tile>
          </mat-grid-list>
        </mat-card>
      </div>
      <div class="produit" [class]="{ 'disabled-form': isFormDisable() }">
        <div class="title title-margin-top">
          <h3>{{ 'product_section_product' | translate }}</h3>
          <mat-card>
            <div class="row">
              <div class="col-3">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_family' | translate }}</mat-label>
                  <mat-select #familySelect formControlName="familyId" (selectionChange)="familyChange($event.value)" required>
                    <mat-option *ngIf="!families?.length" disabled style="display: none"></mat-option>
                    <div *ngIf="!newFamilyName" class="add-family-option" (click)="addNewFamily()">
                      <span>{{ 'product_add_family' | translate }}</span>
                    </div>
                    <div *ngIf="newFamilyName" class="new-family-option" (click)="selectNewFamily()">
                      <span>{{ newFamilyName }} [{{ newFamilyCode }}]</span>
                      <mat-icon class="edit-icon" (click)="editNewFamily($event)">edit</mat-icon>
                    </div>
                    <mat-option *ngFor="let f of families" [value]="f.familyId" [style.display]="f.familyId === newFamilyId ? 'none' : 'block'"> {{ f.displayName }} [{{ f.code }}] </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-3">
                <mat-form-field>
                  <mat-label>{{ 'product_field_functional_unit' | translate }}</mat-label>
                  <mat-select formControlName="workUnityId" (selectionChange)="changeWorkUnity(unitys, $event.value)" required>
                    <mat-option *ngFor="let u of unitys" [value]="u.workUnityId">
                      {{ u.displayName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-2" *ngIf="hasDensity && !formCrls.isComplexProduct.value && showDensity">
                <mat-form-field>
                  <mat-label *ngIf="!formCrls.cableProduct?.value">{{ 'product_field_mass_per_fu' | translate }}</mat-label>
                  <mat-label *ngIf="formCrls.cableProduct?.value">{{ 'product_field_density_tm3' | translate }}</mat-label>
                  <input matInput formControlName="density" type="number" (change)="setDensity($event.target)" required />
                  <mat-error *ngIf="formCrls.density.errors?.required && !formCrls.cableProduct?.value">{{ 'product_error_mass_required' | translate }}</mat-error>
                  <mat-error *ngIf="formCrls.density.errors?.required && formCrls.cableProduct?.value">{{ 'product_error_density_required' | translate }}</mat-error>
                  <mat-error *ngIf="formCrls.density.errors?.positive && !formCrls.cableProduct?.value">{{ 'product_error_mass_positive' | translate }}</mat-error>
                  <mat-error *ngIf="formCrls.density.errors?.positive && formCrls.cableProduct?.value">{{ 'product_error_density_positive' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col-2" *ngIf="isHygrometryRateVisible">
                <mat-form-field>
                  <mat-label>{{ 'product_field_hygrometry_rate' | translate }}</mat-label>
                  <input matInput formControlName="hygrometryRate" type="number" />
                  <mat-error *ngIf="formCrls.hygrometryRate.errors?.max">{{ 'product_error_hygrometry_max' | translate }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row rendu" *ngIf="!formCrls.isComplexProduct.value">
              <div class="col-2">
                <mat-checkbox formControlName="endProduct"> {{ 'product_checkbox_end_product' | translate }} </mat-checkbox>
              </div>
              <div class="col-3">
                <mat-checkbox formControlName="coatedFormula"> {{ 'product_checkbox_coated_formula' | translate }} </mat-checkbox>
              </div>
              <div class="col-3">
                <mat-checkbox formControlName="whiteFormula"> {{ 'product_checkbox_white_formula' | translate }} </mat-checkbox>
              </div>
              <div class="col-2">
                <mat-checkbox formControlName="isPipeProduct" *ngIf="acuView" (change)="pipeProductChange($event)"> {{ 'product_checkbox_pipe' | translate }} </mat-checkbox>
              </div>
              <div class="col-2">
                <mat-checkbox formControlName="isJoinProduct" *ngIf="acuView" (change)="joinProductChange($event)"> {{ 'product_checkbox_join' | translate }} </mat-checkbox>
              </div>
              <div class="col-2">
                <mat-checkbox formControlName="cableProduct" *ngIf="acuView"> {{ 'product_checkbox_cable' | translate }} </mat-checkbox>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'common_field_description' | translate }}</mat-label>
                  <textarea type="text" formControlName="description" rows="3" matInput class="resetPointerEvents" [readonly]="isFormDisable()"></textarea>
                </mat-form-field>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="mt-4" [class]="{ 'disabled-form': isFormDisable() }">
        <mat-checkbox *ngIf="manageProductsEcoPro" formControlName="isComplexProduct" (change)="complexProductChange($event)"> {{ 'product_checkbox_complex_product' | translate }} </mat-checkbox>
      </div>
      <div *ngIf="formCrls.isComplexProduct.value" [class]="{ 'disabled-form': isFormDisable() }">
        <div class="composition">
          <div class="title title-margin-top">
            <h3>{{ 'product_section_composition' | translate }}</h3>
            <button mat-mini-fab (click)="addProductCompo(currentItem)" type="button">
              <mat-icon>add</mat-icon>
            </button>
          </div>
          <div>
            <mat-accordion hideToggle>
              <mat-expansion-panel expanded>
                <mat-expansion-panel-header #panel (click)="panel._toggle()">
                  <mat-panel-title>
                    <div class="row text-bold">
                      <div class="col-1 text-center">
                        <mat-icon (click)="panel._toggle()">
                          {{ panel._isExpanded() ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
                        </mat-icon>
                      </div>
                      <div class="col-1">{{ 'common_field_code' | translate }}</div>
                      <div class="col-1 text-center">{{ 'common_field_label' | translate }}</div>
                      <div class="col-2 text-center">{{ 'common_field_transport' | translate }}</div>
                      <div class="col-1">{{ 'common_field_energy' | translate }}</div>
                      <div class="col-1">{{ 'common_field_distance' | translate }}</div>
                      <div class="col-1 text-center">{{ 'common_double_freight' | translate }}</div>
                      <div class="col-2">{{ 'dialog_complex_product_col_work_unit' | translate }}</div>
                      <div class="col-1">{{ 'common_field_quantity' | translate }}</div>
                      <div class="col-1"></div>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <ng-container *ngIf="currentItem?.productsComposition && currentItem?.productsComposition?.length; else no_products">
                  <div class="row" [ngClass]="{ backgroundColor: indexPro % 2 == 0 }" *ngFor="let item of currentItem?.productsComposition; let indexPro = index">
                    <div class="col-1 text-center">
                      <badge-statut [item]="item"></badge-statut>
                    </div>
                    <div class="col-1">
                      {{ item.code }}
                    </div>
                    <div class="col-1 align-center">
                      {{ item.displayName }}
                      <mat-icon class="edit-product-name-icon" (click)="switchProduct(item)"> change_circle </mat-icon>
                    </div>
                    <div class="col-2 text-center">
                      <span>
                        {{ item.transportName ? item.transportName : 'Aucun transport' }}
                        <mat-icon class="transport-deleted" [matTooltip]="'Le transport \'' + item.transportName + '\' a été supprimé'" *ngIf="item.transportDeleted">error </mat-icon>
                      </span>
                    </div>
                    <div class="col-1">
                      <div>
                        {{ item?.energyName ? item?.energyName : 'Aucune énergie' }}
                      </div>
                    </div>
                    <div class="col-1">
                      <div>
                        {{ item.distance }}
                      </div>
                    </div>
                    <div class="col-1 text-center">
                      <div>
                        <mat-checkbox [checked]="item?.doubleCargo ? true : false" (change)="item.doubleCargo = !item?.doubleCargo"> </mat-checkbox>
                      </div>
                    </div>
                    <div class="col-2">
                      {{ item.productWorkUnit }}
                    </div>
                    <div class="col-1">
                      {{ item.quantity }}
                    </div>
                    <div class="col-1 icon-color text-center">
                      <mat-icon [matTooltip]="'common_tooltip_edit' | translate" (click)="editProductCompo(item)">edit</mat-icon>
                      <mat-icon [matTooltip]="'common_tooltip_delete' | translate" (click)="deleteProductCompo(indexPro)"> delete_outline</mat-icon>
                    </div>
                  </div>
                </ng-container>
                <ng-template #no_products>
                  <div *ngIf="this.formSubmitted || this.compositionTouched" class="mat-error compositionError">{{ 'product_error_composition_required' | translate }}</div>
                </ng-template>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </div>

      <div class="version col-6" *ngIf="currentItem && currentItem.resourceId && currentItem.ruade">
        <h3 class="title-margin-top" style="opacity: 0.8">{{ 'ref_section_db_version' | translate }}</h3>
        <mat-card>
          <div class="row">
            <div class="col-12">
              <mat-form-field>
                <mat-label>{{ 'ref_field_choose_version' | translate }}</mat-label>
                <mat-select [multiple]="false" formControlName="versionId" (selectionChange)="onVersionChange($event.value)">
                  <mat-option *ngFor="let p of dbVersions" [value]="p.versionId">
                    {{ p.versionName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </mat-card>
      </div>

      <div class="cout" *ngIf="hasDensity && !formCrls.isComplexProduct.value && showDensity">
        <div class="title title-margin-top">
          <h3>{{ 'product_section_env_cost_fu' | translate }}</h3>
          <mat-card formGroupName="ceu">
            <div class="row">
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_energy_mj' | translate }}</mat-label>
                  <input matInput required type="number" [value]="formCrls.fCeu.get('en')?.value" (change)="setFceuValue($event.target, 'en')" [disabled]="formCrls.isComplexProduct.value || isFormDisable()" />
                  <mat-error *ngIf="formCrls.fCeu?.get('en')?.invalid">{{ 'ref_error_energy_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_co2_t' | translate }}</mat-label>
                  <input matInput required type="number" [value]="formCrls.fCeu.get('co')?.value" (change)="setFceuValue($event.target, 'co')" [disabled]="formCrls.isComplexProduct.value || isFormDisable()" />
                  <mat-error *ngIf="formCrls.fCeu?.get('co')?.invalid">{{ 'ref_error_co2_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_natural_aggregates' | translate }}</mat-label>
                  <input matInput required type="number" [value]="formCrls.fCeu.get('gn')?.value" (change)="setFceuValue($event.target, 'gn')" [disabled]="formCrls.isComplexProduct.value || isFormDisable()" />
                  <mat-error *ngIf="formCrls.fCeu?.get('gn')?.invalid">{{ 'ref_error_aggregates_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_coated_aggregates' | translate }}</mat-label>
                  <input matInput required type="number" [value]="formCrls.fCeu.get('ae')?.value" (change)="setFceuValue($event.target, 'ae')" [disabled]="formCrls.isComplexProduct.value || isFormDisable()" />
                  <mat-error *ngIf="formCrls.fCeu?.get('ae')?.invalid">{{ 'ref_error_coated_aggregates_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_recycled_materials' | translate }}</mat-label>
                  <input matInput required type="number" [value]="formCrls.fCeu.get('mr')?.value" (change)="setFceuValue($event.target, 'mr')" [disabled]="formCrls.isComplexProduct.value || isFormDisable()" />
                  <mat-error *ngIf="formCrls.fCeu?.get('mr')?.invalid">{{ 'ref_error_materials_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col-4">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_reused_spoils' | translate }}</mat-label>
                  <input matInput required type="number" [value]="formCrls.fCeu.get('drc')?.value" (change)="setFceuValue($event.target, 'drc')" [disabled]="formCrls.isComplexProduct.value || isFormDisable()" />
                  <mat-error *ngIf="formCrls.fCeu?.get('drc')?.invalid">{{ 'ref_error_spoils_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col-4">
                <span *ngIf="formCrls.fCeu?.invalid" class="mat-error">
                  {{ 'ref_error_indicators_required' | translate }}
                </span>
              </div>
            </div>
            <div class="row" *ngIf="!formCrls.isComplexProduct.value">
              <div class="col-3" *ngIf="!(formCrls.isComplexProduct.value || isFormDisable())">
                <div class="justificatif">
                  <input id="fceuFile" type="file" #fceuProofUpload class="inputfile" accept="application/pdf" (change)="uploadFceuProof(currentItem.resourceId, fceuProofUpload.files)" #fceuFileInput />
                  <button mat-mini-fab color="accent" class="mini-fab" (click)="fceuFileInput.click()">
                    <mat-icon>add</mat-icon>
                  </button>
                  <label class="cursor" for="fceuFile">{{ 'ref_add_proof_pdf' | translate }}</label>
                </div>
              </div>
              <div class="col-4">
                <div class="justificatif" *ngIf="form.value.fCeuFileName">
                  <button mat-mini-fab color="warn" class="mini-fab" (click)="deleteFceuFile()">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                  <a *ngIf="form.value.fCeuFileDescription; else fCeuFileNotUploaded" [href]="justificationFilePath + form.value.fCeuFileDescription" target="_blank">{{ form.value.fCeuFileName }} </a>
                  <ng-template #fCeuFileNotUploaded>{{ form.value.fCeuFileName }} </ng-template>
                </div>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div class="cout">
        <div class="title title-margin-top">
          <h3>{{ 'ref_section_env_cost_ton' | translate }}</h3>
          <mat-card formGroupName="ceu">
            <div class="row">
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_energy_mj' | translate }}</mat-label>
                  <input
                    matInput
                    type="number"
                    [value]="ceuComputed ? (formCrls.ceu.get('en')?.value | toFixed) : formCrls.ceu.get('en')?.value"
                    (change)="setValue($event.target, 'en')"
                    [required]="!ceuComputed && !formCrls.isComplexProduct.value"
                    [disabled]="formCrls.isComplexProduct.value || isFormDisable() || (hasDensity && !formCrls.isComplexProduct.value && showDensity)" />
                  <mat-error *ngIf="formCrls.ceu?.get('en')?.invalid">{{ 'ref_error_energy_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_co2_t' | translate }}</mat-label>
                  <input
                    matInput
                    type="number"
                    [value]="ceuComputed ? (formCrls.ceu.get('co')?.value | toFixed: 4 : true) : formCrls.ceu.get('co')?.value"
                    (change)="setValue($event.target, 'co')"
                    [required]="!ceuComputed && !formCrls.isComplexProduct.value"
                    [disabled]="formCrls.isComplexProduct.value || isFormDisable() || (hasDensity && !formCrls.isComplexProduct.value && showDensity)" />
                  <mat-error *ngIf="formCrls.ceu?.get('co')?.invalid">{{ 'ref_error_co2_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_natural_aggregates' | translate }}</mat-label>
                  <input
                    matInput
                    type="number"
                    [value]="ceuComputed ? (formCrls.ceu.get('gn')?.value | toFixed) : formCrls.ceu.get('gn')?.value"
                    (change)="setValue($event.target, 'gn')"
                    [required]="!ceuComputed && !formCrls.isComplexProduct.value"
                    [disabled]="formCrls.isComplexProduct.value || isFormDisable() || (hasDensity && !formCrls.isComplexProduct.value && showDensity)" />
                  <mat-error *ngIf="formCrls.ceu?.get('gn')?.invalid">{{ 'ref_error_aggregates_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_coated_aggregates' | translate }}</mat-label>
                  <input
                    matInput
                    type="number"
                    [value]="ceuComputed ? (formCrls.ceu.get('ae')?.value | toFixed) : formCrls.ceu.get('ae')?.value"
                    (change)="setValue($event.target, 'ae')"
                    [required]="!ceuComputed && !formCrls.isComplexProduct.value"
                    [disabled]="formCrls.isComplexProduct.value || isFormDisable() || (hasDensity && !formCrls.isComplexProduct.value && showDensity)" />
                  <mat-error *ngIf="formCrls.ceu?.get('ae')?.invalid">{{ 'ref_error_coated_aggregates_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-3">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_recycled_materials' | translate }}</mat-label>
                  <input
                    matInput
                    type="number"
                    [value]="ceuComputed ? (formCrls.ceu.get('mr')?.value | toFixed) : formCrls.ceu.get('mr')?.value"
                    (change)="setValue($event.target, 'mr')"
                    [required]="!ceuComputed && !formCrls.isComplexProduct.value"
                    [disabled]="formCrls.isComplexProduct.value || isFormDisable() || (hasDensity && !formCrls.isComplexProduct.value && showDensity)" />
                  <mat-error *ngIf="formCrls.ceu?.get('mr')?.invalid">{{ 'ref_error_materials_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col-4">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_reused_spoils' | translate }}</mat-label>
                  <input
                    matInput
                    type="number"
                    [value]="ceuComputed ? (formCrls.ceu.get('drc')?.value | toFixed) : formCrls.ceu.get('drc')?.value"
                    (change)="setValue($event.target, 'drc')"
                    [required]="!ceuComputed && !formCrls.isComplexProduct.value"
                    [disabled]="formCrls.isComplexProduct.value || isFormDisable() || (hasDensity && !formCrls.isComplexProduct.value && showDensity)" />
                  <mat-error *ngIf="formCrls.ceu?.get('drc')?.invalid">{{ 'ref_error_spoils_required' | translate }}</mat-error>
                </mat-form-field>
              </div>
              <div class="col-4">
                <span *ngIf="formCrls.ceu?.invalid && !ceuComputed" class="mat-error">
                  {{ 'ref_error_indicators_required' | translate }}
                </span>
              </div>
            </div>
            <div class="row" *ngIf="!formCrls.isComplexProduct.value">
              <div class="col-3" *ngIf="!(formCrls.isComplexProduct.value || isFormDisable() || (hasDensity && !formCrls.isComplexProduct.value && showDensity))">
                <div class="justificatif">
                  <input id="fileInput" type="file" #proofUpload class="inputfile" accept="application/pdf" (change)="uploadProof(currentItem.resourceId, proofUpload.files)" #fileInput />
                  <button mat-mini-fab color="accent" class="mini-fab" (click)="fileInput.click()">
                    <mat-icon>add</mat-icon>
                  </button>
                  <label class="cursor" for="fileInput">{{ 'ref_add_proof_pdf' | translate }}</label>
                </div>
              </div>
              <div class="col-4">
                <div class="justificatif" *ngIf="form.value.fileName">
                  <button mat-mini-fab color="warn" class="mini-fab" (click)="deleteFile()">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                  <a *ngIf="form.value.fileDescription; else fileNotUploaded" [href]="justificationFilePath + form.value.fileDescription" target="_blank">
                    {{ form.value.fileName }}
                  </a>
                  <ng-template #fileNotUploaded>
                    {{ form.value.fileName }}
                  </ng-template>
                </div>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div class="ressource" #resourceSection>
        <div class="title title-margin-top">
          <h3>{{ 'ref_section_resource_type' | translate }}</h3>
          <mat-card>
            <div class="row">
              <div class="col-4">
                <mat-form-field>
                  <mat-label>{{ 'ref_field_project_type' | translate }}</mat-label>
                  <mat-select [multiple]="true" formControlName="projectType" [compareWith]="compareProjectTypes" required>
                    <mat-option *ngFor="let p of projectTypes" [value]="p" [disabled]="isFormDisable()">
                      {{ p.displayName | localizedLabel: 'projectType' : p.code }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-4">
                <span *ngIf="formCrls.projectType.invalid && (form.controls.projectType.touched || this.formSubmitted)" class="mat-error">{{ form.controls.projectType.errors?.validateProjectType | translate }}</span>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </form>
</div>
